import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material';
import { Router } from '@angular/router';

@Component({
  selector: 'app-need-a-switch',
  templateUrl: './need-a-switch.component.html',
  styleUrls: ['./need-a-switch.component.css']
})
export class NeedASwitchComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<NeedASwitchComponent>,
    private router: Router
  ) { }

  ngOnInit() {
  }

  newReservation(): void {
    this.router.navigate(['/reservations/new']);
    this.dialogRef.close();
  }

  needASwitch(): void {
    this.router.navigate(['/on-site']);
    this.dialogRef.close();
  }

}
